// extracted by mini-css-extract-plugin
module.exports = {"positionCardWrap":"PositionCard_positionCardWrap__F_Sjs","title":"PositionCard_title__n8kp7","tags":"PositionCard_tags__p0dni"};